import { Card } from "@/components/ui/card";
import { Users, TrendingUp } from "lucide-react";
import aboutImage from "@/assets/about-section-image.jpg";
import { useMemberCount } from "@/hooks/useMemberCount";

const AboutSection = () => {
  const { data: counts } = useMemberCount();
  return (
    <section id="impact" className="py-20 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1 animate-fade-in">
            <img
              src={aboutImage}
              alt="Business networking meeting"
              className="rounded-lg shadow-lg w-full"
              width={2560}
              height={1440}
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 animate-fade-in" style={{ animationDelay: "0.2s" }}>
            <h2 className="text-4xl font-bold text-foreground mb-6">
              Connecting Businesses, Building Community
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              At Referral Connection Network, we are committed to fostering a collaborative environment where local businesses can thrive. Our vibrant community is built on shared resources and referrals, empowering members to grow together. Join us to expand your network and unlock exclusive opportunities!
            </p>

            {/* Stats */}
            <div className="grid sm:grid-cols-2 gap-6">
              <Card className="p-6 hover:shadow-lg transition-shadow">
                <div className="flex items-start space-x-4">
                  <div className="bg-primary/10 p-3 rounded-lg">
                    <Users className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <p className="text-3xl font-bold text-foreground">{counts?.total ?? "—"}</p>
                    <p className="text-sm text-muted-foreground mt-1">
                      Members in our network, creating a robust platform for collaboration and growth
                    </p>
                  </div>
                </div>
              </Card>

              <Card className="p-6 hover:shadow-lg transition-shadow">
                <div className="flex items-start space-x-4">
                  <div className="bg-primary/10 p-3 rounded-lg">
                    <TrendingUp className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <p className="text-3xl font-bold text-foreground">150+</p>
                    <p className="text-sm text-muted-foreground mt-1">
                      Referrals exchanged, showcasing the power of our community in driving business success
                    </p>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
